"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfForgotPasswordDto = instanceOfForgotPasswordDto;
exports.ForgotPasswordDtoFromJSON = ForgotPasswordDtoFromJSON;
exports.ForgotPasswordDtoFromJSONTyped = ForgotPasswordDtoFromJSONTyped;
exports.ForgotPasswordDtoToJSON = ForgotPasswordDtoToJSON;
exports.ForgotPasswordDtoToJSONTyped = ForgotPasswordDtoToJSONTyped;
/**
 * Check if a given object implements the ForgotPasswordDto interface.
 */
function instanceOfForgotPasswordDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function ForgotPasswordDtoFromJSON(json) {
    return ForgotPasswordDtoFromJSONTyped(json, false);
}
function ForgotPasswordDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
function ForgotPasswordDtoToJSON(json) {
    return ForgotPasswordDtoToJSONTyped(json, false);
}
function ForgotPasswordDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
    };
}
